module.exports = __webpack_public_path__ + "img/Hero section (6).51549998.png";